<template>
  <section class="distance-comp">
    <b-tabs @input="handleTabChanged">
      <b-tab>
        <template #title>
          <strong style="font-weight: 500; color: black">{{ $t("ItemsAndOrders") }}</strong>
        </template>
        <OrdersAndArticles />
      </b-tab>
      <b-tab>
        <template #title>
          <strong style="font-weight: 500; color: black">{{ $t("InPending") }}</strong>
        </template>
        <InPending ref="inPending" />
      </b-tab>
      <b-tab>
        <template #title>
          <strong style="font-weight: 500; color: black">{{ $t("OrderMovements") }}</strong>
        </template>
        <OrderMovements ref="orderMovements" />
      </b-tab>
      <b-tab>
        <template #title>
          <strong style="font-weight: 500; color: black">{{ $t("OrderMovementsHistory") }}</strong>
        </template>
        <OrderMovementsHistory ref="orderMovementsHistory" />
      </b-tab>
    </b-tabs>
  </section>
</template>

<script>
import OrdersAndArticles from '@/components/InternalMovement/OrdersAndArticles.vue'
import InPending from '@/components/InternalMovement/InPending.vue'
import OrderMovements from '@/components/InternalMovement/OrderMovements.vue'
import OrderMovementsHistory from '@/components/InternalMovement/OrderMovementsHistory.vue'


export default {
  components: {
    OrdersAndArticles,
    InPending,
    OrderMovements,
    OrderMovementsHistory,

  },
  methods: {
    handleTabChanged(newTabIndex) {
      if (newTabIndex === 1) {
        this.$refs.inPending.updateData();
      } else if (newTabIndex === 2) {
        this.$refs.orderMovements.updateOrderMovements();
      } else if (newTabIndex === 3) {
        this.$refs.orderMovementsHistory.updateOrderMovementsHistory();
      }
    },
  },
}
</script>

  <style scoped>
  .distance-comp {
    padding: 75px 15px 15px 90px;
  }
  @media screen and (max-width: 1190px) {
    .distance-comp {
        padding: 90px 0.75rem 15px 0.75rem;
    }
}
  </style>
